import { useContext } from 'react';
import { ModalDispatchContext } from './ModalContext';
/**
 * A custom hook to access the modal dispatch functions (`openModal`, `closeModal`).
 * This hook ensures that it is used within a ModalOrchestrator context.
 *
 * @returns The modal dispatch functions.
 * @throws An error if used outside of a ModalOrchestrator provider.
 */
export const useModalDispatch = () => {
    const dispatch = useContext(ModalDispatchContext);
    if (!dispatch) {
        throw new Error('useModalDispatch must be used within a ModalOrchestrator provider');
    }
    return dispatch;
};
